<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 text-dark">Add New Vehicle</h4>

      <form @submit.prevent="submitForm">
        <div class="row">
          <!-- License Plate -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="licensePlate" class="form-label">{{ $t('common.labels.licensePlate') }}</label>
              <input
                type="text"
                id="licensePlate"
                class="form-control"
                v-model="form.licensePlate"
                :placeholder="$t('common.placeholders.enterLicensePlate')"
                required
              />
            </div>
          </div>

          <!-- Brand -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="brand" class="form-label">{{ $t('common.labels.brand') }}</label>
              <input
                type="text"
                id="brand"
                class="form-control"
                v-model="form.brand"
                :placeholder="$t('common.placeholders.enterBrand')"
                required
              />
            </div>
          </div>

          <!-- Model -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="model" class="form-label">{{ $t('common.labels.model') }}</label>
              <input
                type="text"
                id="model"
                class="form-control"
                v-model="form.model"
                :placeholder="$t('common.placeholders.enterModel')"
                required
              />
            </div>
          </div>

          <!-- Color -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="color" class="form-label">{{ $t('common.labels.color') }}</label>
              <input
                type="text"
                id="color"
                class="form-control"
                v-model="form.color"
                :placeholder="$t('common.placeholders.enterColor')"
                required
              />
            </div>
          </div>

          <!-- Year -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="year" class="form-label">{{ $t('common.labels.year') }}</label>
              <input
                type="number"
                id="year"
                class="form-control"
                v-model="form.year"
                :placeholder="$t('common.placeholders.enterYear')"
                required
              />
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between">
          <router-link to="/parc">
            <button type="button" class="btn btn-outline-secondary px-4">
              Cancel
            </button>
          </router-link>
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            Add Vehicle
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddParc",
  data() {
    return {
      form: {
        licensePlate: "",
        brand: "",
        model: "",
        color: "",
        year: ""
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Vehicle added:", this.form);
      alert("Vehicle added successfully!");
      this.$router.push("/parc");
    }
  }
};
</script>
